import React, { useEffect, useState } from 'react'
import { useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Paper } from '@mui/material'
import { Container, Col, Row } from 'react-bootstrap'
import { Form } from 'antd'
import { FaEdit } from 'react-icons/fa'
import { IoAddCircleOutline, IoRemoveCircle } from 'react-icons/io5'

import DataTable from 'Shared/Components/DataTable'
import useFetchData from 'Shared/Hooks/useFetchData'
import PopupModal from 'Shared/Components/PopupModal'
import { CheckList, Dropdown, TextInput, FormContainer } from 'Shared/Components/FormComponents'
import { showSuccess } from 'Shared/Components/NotifyToast'
import { apiUrl } from 'Shared/utils'
import { useRef } from 'react'

const roleOptions = [
  {"value": "pm", "label": "Project Manager"},
  {"value": "so", "label": "Safty Officer"},
  {"value": "client", "label": "Client" }
]

const RoleTable = ({ user, closemodal }) => {
  const { setPageLoading } = useOutletContext()
  
  const { send } = useFetchData()
  const { t, i18n } = useTranslation()
  const [form] = Form.useForm()

  const tableRef = useRef()

  const [roles, setRoles] = useState()
  const [projects, setProjects] = useState()

  const [modalOpen, setModalOpen] = useState({ "isOpen": false, "mode": null })

  const loadUserRole = async () => {
    const body = await send({
      method: "GET",
      url: `${apiUrl}/user/user_roles/${user["user_id"]}`,
      returnType: "json"
    })

    setRoles(body.map((i) => ({
      "project_code": i["project_code"],
      "role": i["role"],
      "projectName": i["project_name"][i18n.language.toLowerCase()],
      "roleName": t(`users_role_${i["role"]}`)
    })))
  }

  const loadProjects = async () => {
    const body = await send({
      method: "GET",
      url: `${apiUrl}/user/projects`,
      returnType: "json"
    })

    setProjects(body.map((i) => ({
      "value": i["project_code"],
      "label": i[`project_name_${i18n.language.toLowerCase()}`],
    })))
  }

  useEffect(() => {
    const init = async () => {
      await Promise.all([
        loadUserRole(),
        loadProjects()
      ])

      setPageLoading(false)
    }

    init()
  }, [])

  const toggleForm = (project, mode) => {
    form.setFieldsValue({
      "user": user["username"],
      "project": project ? project["project_code"] : null,
      "role": project ? project["role"] : null,
    })

    setModalOpen({
      "isOpen": !modalOpen["isOpen"],
      "mode": mode
    })
  }

  const onFinish = async (values) => {
    setPageLoading(true)

    let method = null

    switch (modalOpen["mode"]) {
      case "Add":
        method = "POST"
        break
      case "Edit":
        method = "PUT"
        break
      case "Delete":
        method = "DELETE"
        break
    }

    const res = await send({
      url: `${apiUrl}/user/project_permission`,
      method: method,
      contentType: "json",
      body: {
        "user": user["user_id"],
        "project": values["project"],
        "role": values["role"],
      }
    })

    if (res != null) {
      toggleForm()
      closemodal()
      
      showSuccess(t("general_success"))
    }

    setPageLoading(false)
  }

  return (<>
    <Container fluid className="mainContainer" style={{ backgroundColor: "white", borderRadius: "15px" }}>
      <Row style={{ height: "100%" }}>
        <Col xs={12} style={{ height: "100%", overflow: "auto", padding: "10px" }}>
          <Paper elevation={0} sx={{ height: "100%", display: "flex", flexFlow: "column" }}>
            <DataTable
              data={roles} count={null} ref={tableRef}
              columns={{
                "projectName": { "label": t("admin_projects_projectName"), "sorting": false, "nowrap": false },
                "roleName": { "label": t("users_role"), "sorting": false, "nowrap": true },
              }}
              appActions={() => { return [
                {icon: <IoAddCircleOutline size={20}/>, text: t("general_add"), onClick: function() { toggleForm(null, "Add") }}
              ]}}
              renderActions={(row) => { return [
                {icon: <FaEdit size={20}/>, text: t("general_edit"), onClick: function(row) { toggleForm(row, "Edit") }},
                {icon: <IoRemoveCircle size={20}/>, text: t("general_remove"), onClick: function(row) { toggleForm(row, "Delete") }},
              ]}}
            />
          </Paper>
        </Col>
      </Row>
    </Container>

    <PopupModal isOpen={modalOpen["isOpen"]} maxHeight="50%" width="70%" close toggle={toggleForm}>
      <FormContainer form={form} onFinish={onFinish} initialValues={{}}>
        <TextInput field_name={t("users_username")} field_id="user" required disabled/>
        <Dropdown field_name={t("admin_projects_projectName")} field_id="project" props={{"options": projects}} required={true} disabled={["Edit", "Delete"].includes(modalOpen["mode"])}/>
        <CheckList field_name={t("users_role")} field_id="role" props={{"options": roleOptions}} required={true} disabled={modalOpen["mode"] === "Delete"}/>
      </FormContainer>
    </PopupModal>
  </>)
}

export default RoleTable
